import React, { useState, useEffect, useCallback } from 'react';
import { useOutletContext, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
//api
import { getDetailDelivery } from 'api/company';
//helpers
import { capitalizeText } from 'helpers';
//components
import Title from 'components/backoffice/texts/title';
import DeliveriesForm from 'components/backoffice/forms/deliveriesForm';

const EditDeliveries = () => {
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [delivery, setDelivery] = useState(null);
  const { t } = useTranslation(['backoffice']);
  const {setTitle} = useOutletContext()

  useEffect(() => {
    const fetchDelivery = async () => {
      try {
        const { data, status } = await getDetailDelivery(id);
        if (status === 200) {
          setDelivery(data);
        }
      } catch (error) {}
    };
    fetchDelivery();
  }, [id]);

  useEffect(()=>{
    if(delivery){
      setTitle(t('edit', {title: capitalizeText(delivery?.province_name)}))
    }
    return () => {
      setTitle('');
    }
  },[delivery,setTitle])

  return (
    <div className="mt-2">
      <Title text={t('editdelivery')} />
      <DeliveriesForm 
        deliveryData={delivery} 
        isLoading={loading} 
        isEditing={true} 
      />
    </div>
  );
};

export default EditDeliveries;
